module.exports = __webpack_public_path__ + "img/zonnestroom-5sterren-google-hor.3ec1191d.png";